import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import ConfirmModal from '../../../ConfirmModal';
import MarkdownToHtml from '../../../MarkdownToHtml';

const AddFlightInfoModal = ({ onCancel }) => {
  const { travelAgency } = useSelector((store) => store.user);
  const tripConfirmationMessages =
    (travelAgency && travelAgency.settings && travelAgency.settings.tripConfirmationMessages) || {};

  const airDesk =
    travelAgency && travelAgency.name ? `the ${travelAgency.name} Air Desk` : 'the Air Desk';

  const message =
    tripConfirmationMessages.addFlight ||
    [
      'Adding a flight to an existing booking with multiple guests is not currently supported. This booking only has primary guest details on file.',
      `To add a flight, please book a new trip, or contact ${airDesk} (available via the Help menu at the top of this page) for assistance.`,
    ].join('\n\n');

  return (
    <ConfirmModal
      onCancel={onCancel}
      cancelButtonLabel="Close"
      event="Trip confirmation - Add Flight click (add not allowed)"
      eventDetail={message}
      message={<MarkdownToHtml content={message} className="text-black" />}
    />
  );
};

AddFlightInfoModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
};

export default AddFlightInfoModal;
